module.exports = __webpack_public_path__ + "static/media/ico-spotify.6beab133.svg";